import script from "./AppHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=f406b384&lang=scss"

const __exports__ = script;

export default __exports__